import React, {Component} from 'react'
import {Route, Switch, withRouter} from 'react-router-dom'
import {langCodes} from '../../constants/consts-languages'
import styles from './App.css'
import PropTypes from 'prop-types'
import NotFound from "../../templates/notfound/NotFound"
import Page from "../../templates/Page"
import AudioGuidePlayerContext from '../../contexts/AudioGuidePlayerContext'
import smoothscroll from 'smoothscroll-polyfill'
import AudioGuidePlayer from '../AudioGuideComponents/AudioGuidePlayer/AudioGuidePlayer'
import { analyticsEvent } from '../../services/service-analytics'

// kick off the polyfill!
smoothscroll.polyfill();

// kick off the polyfill!
smoothscroll.polyfill();
class App extends Component {
	static propTypes = {
		location: PropTypes.object.isRequired
	};
  
	constructor(props) {
    super(props);
    
		this.getCurrentLanguage = this.getCurrentLanguage.bind(this);
		this.getRouterPath = this.getRouterPath.bind(this);
		this.setAudioGuidePlayerData = this.setAudioGuidePlayerData.bind(this);

    this.state = {
      audioGuidePlayerCategory: null,
      audioGuidePlayerTitle: null,
      audioGuidePlayerUrl: null
    }
	}

	getCurrentLanguage() {
		let lang = document.documentElement.lang;

		const isDevEnvironment = Boolean(lang === "<?=env('language') ? env('language') : 'da' ?>");
		if (isDevEnvironment) {
			const firstPath = window.location.pathname.split('/')[1];
			if (langCodes[firstPath] || firstPath === '') lang = firstPath;
		}

		if (!lang || lang === 'da' || !langCodes[lang]) return null;

		return `/${lang}`;
	}

	getRouterPath() {
		const lang = this.getCurrentLanguage();
		const path = `/:pageType?/:pageId?`;

		if (lang) {
			return `/:lang?${path}`;
		} else {
			return path;
		}
	}

  setAudioGuidePlayerData(category, title, url) {
    analyticsEvent(`audio guide - ${category}`, 'play', title)
    this.setState({
      audioGuidePlayerCategory: category,
      audioGuidePlayerTitle: title,
      audioGuidePlayerUrl: url
    })
  }

	render() {
    const { audioGuidePlayerCategory: category, audioGuidePlayerTitle: title, audioGuidePlayerUrl: url } = this.state
    const playerActive = title && url ? true : false

		return (
      <div className={`${styles.App} ${playerActive && styles.withAudioGuidePlayer}`}>
				<Switch>
          <Route
            exact
            path={this.getRouterPath()}
            key={'page'}
            render={(props) => (
              <AudioGuidePlayerContext.Provider value={{ setData: this.setAudioGuidePlayerData }}>
                <Page {...props} />
              </AudioGuidePlayerContext.Provider>
            )}
          />
					<Route key={'notfound'} component={NotFound} />
				</Switch>
        {playerActive && (
          <AudioGuidePlayer category={category} title={title} url={url} setData={this.setAudioGuidePlayerData} />
        )}
			</div>
		);
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js